import { useCallback } from "react"
import {
  ArrowRight,
  BannerNegative,
  Block,
  Button,
  HeadingLarge,
  LabelLarge,
  ListItem,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { useSwapReview } from "#/shared/hooks"
import { SwapFormValue } from "#/shared/types"
import { getCurrencySymbol, separateThousandsWithComma } from "#/shared/utils"
import { TokenIcon } from "#/ui/Token"

import { ComponentStepProps, useStepperModalContext } from "../StepperModal"

import SwapReviewItem from "./SwapReviewItem"

export default function SwapReview({ onClickContinue: _ }: ComponentStepProps) {
  const { values } = useStepperModalContext<SwapFormValue>()
  const { sellToken, buyToken, slippage } = values

  const { networkFee, transactionFee, transactionTotal, isSlippageToHigh } =
    useSwapReview(sellToken.token, sellToken.amount, Number(slippage))

  const [css, theme] = useStyletron()

  // TODO: Implement swap contract interaction
  const swapHandler = useCallback(() => {}, [])

  return (
    <Block
      className={css({
        padding: `${theme.sizing.scale700} ${theme.sizing.scale700}`,
        marginTop: theme.sizing.scale500,
        height: "100%",
      })}
    >
      <Block
        className={css({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: theme.sizing.scale300,
        })}
      >
        <TokenIcon token={sellToken.token} size={theme.sizing.scale1600} />
        <ArrowRight color={theme.colors.black} size={theme.sizing.scale600} />
        <TokenIcon token={buyToken.token} size={theme.sizing.scale1600} />
      </Block>

      <HeadingLarge
        className={css({
          textAlign: "center",
          margin: theme.sizing.scale700,
        })}
      >
        Swap {sellToken.amount} {getCurrencySymbol(sellToken.token)} for{" "}
        {buyToken.amount} {getCurrencySymbol(buyToken.token)}
      </HeadingLarge>
      {isSlippageToHigh && (
        <BannerNegative
          artworkType="icon"
          overrides={{ Root: { style: () => ({ marginInline: 0 }) } }}
        >
          {/* TODO: Update with correct text content */}
          Slippage over 5% message displayed
        </BannerNegative>
      )}
      <SwapReviewItem
        title="Swap"
        value={`${sellToken.amount} ${getCurrencySymbol(sellToken.token)}`}
      />
      <SwapReviewItem
        title="Receive"
        value={`${buyToken.amount} ${getCurrencySymbol(buyToken.token)}`}
      />
      <SwapReviewItem
        title="Slippage"
        value={`${slippage} %`}
        showWarning={isSlippageToHigh}
      />
      <SwapReviewItem
        title="Current Network Fee"
        tooltip="Current Netowrk Fee" // TODO: Update with correct tooltip
        value={`${networkFee} ${getCurrencySymbol("mBTC")}`}
      />
      <SwapReviewItem
        title="Transaction Fee"
        tooltip="Transaction Fee" // TODO: Update with correct tooltip
        value={`${transactionFee} ${getCurrencySymbol(sellToken.token)}`}
      />
      <ListItem
        overrides={{
          Content: {
            style: () => ({
              border: "none",
              minHeight: "42px",
              marginLeft: theme.sizing.scale200,
              paddingRight: theme.sizing.scale200,
            }),
          },
        }}
        endEnhancer={() => (
          <LabelLarge>
            ${separateThousandsWithComma(transactionTotal, 2, 2)}
          </LabelLarge>
        )}
      >
        <LabelLarge>Total</LabelLarge>
      </ListItem>
      <Button
        onClick={swapHandler}
        size="large"
        width="100%"
        overrides={{
          BaseButton: { style: () => ({ marginTop: theme.sizing.scale200 }) },
        }}
      >
        Swap
      </Button>
    </Block>
  )
}
